import React, { useReducer, useContext, useEffect, createContext } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import Divider from '@material-ui/core/Divider';
import CustomersActionsButtons from './CustomersActionsButtons';
import { __ } from '../../../../../utils/i18n';
import CustomersSearchBox from './CustomersSearchBox';
import CustomersList from './CustomersList';
import { initialState, reducer, actions } from './reducer';
import { makeStyles } from '@material-ui/core/styles';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '&>*': {
      marginBottom: theme.spacing(1),
    },
  },
}));

export const store = createContext(null);
const { Provider } = store;

const Customers = () => {
  useTitle('مدیریت صاحبان بار')
  const classes = useStyles();
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <Provider value={{ state, dispatch, actions }}>
      <FullCard title="مدیریت صاحبان‌بار" actions={<CustomersActionsButtons />}>
        <div className={classes.root}>
          <CustomersSearchBox />
          <Divider />
          <CustomersList />
        </div>
      </FullCard>
    </Provider>
  );
};

export default React.memo(Customers);
